import React from 'react';
import { Props } from './UWGrid.types';
import styles from './UWGrid.module.scss';
import Masonry from 'react-masonry-css';

const UWGrid: React.FC<Props> = ({ children }) => {
  return (
    <div>
      <Masonry breakpointCols={3} className={styles.masonryGrid} columnClassName={styles.masonryGridColumn}>
        {children}
      </Masonry>
    </div>
  );
};

export default UWGrid;
